import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Data de hoje no fuso local, formato YYYY-MM-DD (evita off-by-one do toISOString UTC). */
export function todayLocalYMD() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Formata YYYY-MM-DD (ou ISO) para DD/MM/YYYY sem deslocar o dia por timezone.
 * `new Date("YYYY-MM-DD")` é meia-noite UTC e no Brasil vira o dia anterior.
 */
export function formatDateOnly(value) {
  if (!value) return "";
  const str = String(value);
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  try {
    return new Date(str).toLocaleDateString("pt-BR");
  } catch {
    return str;
  }
}

/** 0 = início, 1 = normal, 2 = fim de expediente. */
export function ancoraExpedienteVisita(visita) {
  if (visita?.cliente_id) return 1;
  const nome = String(visita?.cliente_nome || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (nome.includes("inicio de expediente")) return 0;
  if (nome.includes("fim de expediente")) return 2;
  return 1;
}

/** Ordena visitas: Início de expediente → clientes → Fim de expediente. */
export function ordenarVisitasRota(visitas) {
  return [...(visitas || [])].sort((a, b) => {
    const da = ancoraExpedienteVisita(a) - ancoraExpedienteVisita(b);
    if (da !== 0) return da;
    return (a.ordem || 0) - (b.ordem || 0);
  });
}
